import { SceneObjectJson } from "@custom-types/core-api-legacy-types";
import { MarkupSceneObject, SlideNodes } from "@custom-types/slide-nodes-types";

/** True iff the passed value is of type SlideNodes */
export function isSlideNodes(value: unknown): value is SlideNodes {
  return typeof value === "object" && value !== null && "slideNodes" in value;
}

/** True iff the scene object is a markup scene object */
export function isMarkupSceneObject(
  sceneObject: SceneObjectJson
): sceneObject is MarkupSceneObject {
  return sceneObject.markupData?.isMarkup === true;
}
